export const constantsCart = {
  // CART_ITEMS_FAIL: 'cart-items-fail',
  // CART_ITEMS_SUCCESS: 'cart-items-success',
  // CART_SAVE_PAYMENT_METHOD: 'cart-save-payment-method',
  CART_INIT: 'cart-init',
  CART_LOAD: 'cart-load',
  CART_EMPTY: 'cart-empty',
  CART_ADD_ITEM: 'cart-add-item',
  CART_EDIT_ITEM: 'cart-edit-item',
  CART_PLUS_ITEM: 'cart-plus-item',
  CART_MINUS_ITEM: 'cart-minus-item',
  CART_REMOVE_ITEM: 'cart-remove-item',
  CART_ADD_CUPON: 'cart-add-cupon',
  CART_ADD_CUPON_NEW: 'cart-add-cupon-new',
}
